export default __webpack_public_path__ + "static/media/video.5a668c83.svg";